import { render, staticRenderFns } from "./StockRecentEntriesOld.vue?vue&type=template&id=53ba7225&scoped=true&"
import script from "./StockRecentEntriesOld.vue?vue&type=script&lang=js&"
export * from "./StockRecentEntriesOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ba7225",
  null
  
)

export default component.exports